import { StyledSpanLink } from "./styles";
import { withInlineVoidElement } from "../../utils";

const NODE_TYPE_REFERENCE_LINK = "reference-link";

export default function ReferenceLink(
  onClickReferenceLink?: (dataId: string, referenceId: string) => void,
) {
  const plugin = (editor: any) => {
    withInlineVoidElement(editor, NODE_TYPE_REFERENCE_LINK);
    return editor;
  };

  plugin.renderElement = (props: any) => {
    const { element, attributes, children } = props;
    if (element.type !== NODE_TYPE_REFERENCE_LINK) {
      return undefined;
    }

    const referenceId = element.data && element.data.reference;
    const dataId = element.data && element.data.dataId;

    console.log("Refrence link data:", element.data, referenceId);

    const onClick = () => {
      if (!referenceId) return;

      // Offline-safe behavior: scroll to referenced element
      const target = document.querySelector(
        `[data-id="${referenceId}"]`, //this is the data-id of the element to scroll to not data-reference-id
      );

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (dataId && typeof onClickReferenceLink === "function") {
        onClickReferenceLink(dataId, referenceId);
      }
    };

    return (
      <StyledSpanLink
        {...attributes}
        className="spf-inline-reference-link"
        data-reference-id={referenceId}
        onClick={onClick}
      >
        {children}
      </StyledSpanLink>
    );
  };

  return plugin;
}
